import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/StudentProfile.css';

const StudentProfile = () => {
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [studentName, setStudentName] = useState("Student");
  const [ratings, setRatings] = useState({});
  const [hoverRatings, setHoverRatings] = useState({});
  const [activeDropdown, setActiveDropdown] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStudentData = async () => {
      const token = localStorage.getItem("token");
      if (!token) return navigate("/customError");

      try {
        const response = await fetch("http://193.123.94.90/student-profile", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({}),
        });

        if (response.ok) {
          const data = await response.json();
          setStudentName(data.name || "Student");

          const transformedCourses = (data.coursename || []).map((courseName, index) => ({
            title: courseName,
            teacher: data.teachers?.[index] || "Unknown Teacher",
            level: data.courselevel?.[index] || "Unknown Level",
            rating: data.ratings?.[index] || "No Rating",
            resource: data.resources?.[index] || "#",
            tutor_id: data.tutorId?.[index] || "Unknown ID",
          }));

          setEnrolledCourses(transformedCourses);

          if (transformedCourses.length > 0) {
            const enrolledCourseData = transformedCourses.map((course) => ({
              title: course.title,
              teacher: course.teacher,
              level: course.level,
              tutor_id: course.tutor_id,
            }));
            localStorage.setItem("enrolledCourses", JSON.stringify(enrolledCourseData));
          }
        } else {
          navigate("/customError");
        }
      } catch (error) {
        console.error("Error fetching student data:", error);
        navigate("/customError");
      }
    };

    fetchStudentData();
  }, []);

  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const handleRatingSubmit = async (index, value) => {
    const userRating = Number(value);
    const { title: courseName, level: courseLevel, tutor_id: tutorId } = enrolledCourses[index];
    setRatings(prev => ({ ...prev, [index]: userRating }));

    const payload = {
      course_name: courseName,
      course_level: courseLevel,
      tutor_id: tutorId,
      rating: userRating,
    };

    try {
      const token = localStorage.getItem("token");
      const res = await fetch("http://193.123.94.90/course-rate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => null);
        throw new Error(err?.message || `HTTP ${res.status}`);
      }

      const { averageRating } = await res.json();
      setEnrolledCourses(prev =>
        prev.map((c, i) => (i === index ? { ...c, rating: averageRating } : c))
      );
    } catch (err) {
      console.error("Error saving rating:", err);
      alert("Could not save rating.");
      setRatings(prev => {
        const copy = { ...prev };
        delete copy[index];
        return copy;
      });
    }
  };

  const handleSignOut = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <div className="position-relative min-vh-100" style={{ backgroundColor: '#ffeae9', cursor: 'url("/pencil-cursor.png"), auto' }}>
      <div style={{
        backgroundImage: 'url("/background.jpg")',
        backgroundSize: 'contain',
        backgroundRepeat: 'repeat',
        backgroundPosition: 'center',
        opacity: 0.06,
        position: 'absolute',
        inset: 0,
        zIndex: 0
      }}></div>

      <div className="container position-relative py-4" style={{ zIndex: 1 }}>
        <div className="position-absolute top-0 start-0 m-3">
          <button className="btn btn-sm btn-outline-danger" onClick={handleSignOut}>Sign Out</button>
        </div>

        <div className="position-absolute top-0 end-0 m-3 d-flex align-items-center gap-2">
          <Link to="/chat">
            <img src="/chatlink-logo.png" alt="ChatLink" width="45" height="45" />
          </Link>
          <Link to="/chatapp">
            <img src="/msg1.jpeg" alt="Messages" width="45" height="45" />
          </Link>
        </div>

        <div className="text-center mb-4">
          <h1 className="display-4">{studentName}'s Profile</h1>
          <button className="btn btn-sm rounded-pill px-3" style={{ backgroundColor: '#f5b5b5', color: 'white' }} onClick={() => navigate("/addStudentCourse")}>
            + Add Courses
          </button>
        </div>

        <h3 className="mb-4">Enrolled Courses</h3>
        <div className="row g-4">
          {enrolledCourses.length > 0 ? (
            enrolledCourses.map((course, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div
                  className="card shadow-sm rounded-4"
                  onMouseEnter={() => toggleDropdown(index)}
                  onMouseLeave={() => toggleDropdown(null)}
                >
                  <div className="card-body">
                    <h5 className="card-title">{course.title}</h5>
                    {activeDropdown === index && (
                      <>
                        <p><strong>Teacher:</strong> {course.teacher}</p>
                        <p><strong>Level:</strong> {course.level}</p>
                        <p><strong>Resources:</strong>{" "}
                          {course.resource !== "#" ? (
                            <a href={course.resource} target="_blank" rel="noopener noreferrer">Link</a>
                          ) : (
                            "No Resources Provided"
                          )}
                        </p>
                        <div className="d-flex align-items-center">
                          <div className="me-2" style={{ width: "90px" }}><strong>Rating:</strong> {hoverRatings[index] ?? course.rating}</div>
                          <div className="rating-wrapper">
                            <div
                              className="avg-star-rating interactive"
                              onMouseMove={(e) => {
                                const { left, width } = e.currentTarget.getBoundingClientRect();
                                const raw = ((e.clientX - left) / width) * 5;
                                const val = Math.round(raw * 2) / 2;
                                setHoverRatings(h => ({ ...h, [index]: val }));
                              }}
                              onMouseLeave={() =>
                                setHoverRatings(h => {
                                  const copy = { ...h };
                                  delete copy[index];
                                  return copy;
                                })
                              }
                              onClick={() => handleRatingSubmit(index, hoverRatings[index] ?? course.rating)}
                            >
                              <div className="stars-outer">
                                {[1, 2, 3, 4, 5].map(n => <span key={n}>★</span>)}
                              </div>
                              <div
                                className="stars-inner"
                                style={{
                                  width: `${((hoverRatings[index] ?? course.rating) / 5) * 100}%`,
                                }}
                              >
                                {[1, 2, 3, 4, 5].map(n => <span key={n}>★</span>)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No enrolled courses found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentProfile;
